import { apiClient } from './apiClient';

export const BecomePartnerAndContactService = {
  BecomePartnerAndContactSendData: (payload: any) =>
    apiClient('/webshop.public.api.website.create_website_inquiry', 'POST', payload),
};
